import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { isEmpty, map } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import Loading from '../../components/Loading';
import TableList from '../../components/TableList';

import Profiles from '../../../api/Profiles/Profiles';
import * as profilesOps from '../../../api/Profiles/profiles-operations';

const PER_PAGE = 15;

class VideoProfiles extends Component {
  state = {
    isTrashOpen: false
  };

  closeTrash = () => this.setState({ isTrashOpen: false });

  handleHardRemove = async profileId => {
    try {
      await methodPromise('profiles.hardDelete', profileId);
      Bert.alert('Profile deleted!', 'danger');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleRestore = async profileId => {
    try {
      await methodPromise('profiles.restore', profileId);
      Bert.alert('Profile Restored!', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleSoftRemove = async profileId => {
    try {
      await methodPromise('profiles.softDelete', profileId);
      Bert.alert('Profile moved to Trash!', 'warning');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  openTrash = () => this.setState({ isTrashOpen: true });

  render() {
    const {
      profiles,
      totalCountProfiles,
      unfilteredCount,
      match,
      deletedCount,
      deletedProfiles,
      searching,
      sort,
      isPremium,
      currentPage,
      loading,
      changePage,
      handleSearch,
      handleSort,
      history
    } = this.props;
    const { isTrashOpen } = this.state;

    const profilesItemsTable = map(profiles, element => {
      const object = {
        name: profilesOps.getName(element),
        entWineName: profilesOps.getEntWineName(element),
        buffer: profilesOps.getBuffer(element),
        path: profilesOps.getPath(element),
        clasify: profilesOps.getClasify(element),
        updatedAt: profilesOps.getLastUpdate(element),
        createdAt: profilesOps.getCreation(element),
        _id: profilesOps.getId(element)
      };
      return object;
    });
    const tableHeaders = [
      {
        count: totalCountProfiles,
        filteredCount:
          unfilteredCount === totalCountProfiles ? '' : unfilteredCount - totalCountProfiles,
        name: 'Profiles',
        sortValue: 'name'
      },
      {
        name: 'Entwine',
        sortValue: 'entWineName'
      },
      {
        name: 'Buffer (m)',
        sortValue: 'buffer'
      },
      {
        name: 'Clasificación',
        sortValue: 'clasify'
      },
      { name: 'Url', sortValue: 'path' },
      {},
      {},
      {},
      {},
      {
        isHiddenOnXS: true,
        name: 'Last Updated',
        sortValue: 'updatedAt'
      },
      {
        isHiddenOnXS: true,
        name: 'Created',
        sortValue: 'createdAt'
      },
      {
        isButtonColumn: true
      },
      {
        isButtonColumn: true
      }
    ];
    const newItems = [
      {
        eventKey: 1,
        isFreeUserAtLimit: false,
        itemName: 'Profiles',
        newItemRoute: `${match.url}/new`
      }
    ];
    const trashProps = {
      deletedCount,
      deletedItems: deletedProfiles,
      isTrashOpen,
      closeTrash: this.closeTrash,
      deleteItem: this.handleHardRemove,
      restoreItem: this.handleRestore
    };
    const tablePageHeaderProps = {
      hasSearchInput: true,
      isPremium,
      newItems,
      searching,
      handleSearch
    };
    const tableHeaderRowProps = {
      hasTrash: true,
      sort,
      tableHeaders,
      handleSort,
      openTrash: this.openTrash
    };
    const tableContentProps = {
      additionalInfo: true,
      additionalInfoFields: [
        'entWineName',
        'buffer',
        'clasify',
        'path',
        profile => profilesOps.getEntWineName(profile),
        profile => profilesOps.getBuffer(profile),
        profile => profilesOps.getClasify(profile),
        profile => profilesOps.getPath(profile)
      ],
      duplicateButton: true,
      history,
      hoverItem: () => {},
      isTableEmpty: isEmpty(profiles),
      itemIdentifier: 'id',
      itemName: 'Profiles',
      items: profilesItemsTable,
      loading,
      match,
      numberOfColumns: 8,
      openNewTabButton: true,
      duplicateItem: this.handleDuplicate,
      softDeleteItem: this.handleSoftRemove
    };
    const tablePaginationProps = {
      currentPage,
      itemsPerPage: PER_PAGE,
      totalCountProfiles,
      changePage
    };

    if (loading) return <Loading />;
    return (
      <TableList
        childProps={{
          trashProps,
          tablePageHeaderProps,
          tableHeaderRowProps,
          tableContentProps,
          tablePaginationProps
        }}
        isFreeUserAtLimit={false}
        isPaginationOn
      />
    );
  }
}

VideoProfiles.defaultProps = {
  profiles: [],
  totalCountProfiles: 0,
  unfilteredCount: 0,
  deletedCount: 0,
  deletedProfiles: [],
  loading: true
};

VideoProfiles.propTypes = {
  profiles: PropTypes.array,
  totalCountProfiles: PropTypes.number,
  unfilteredCount: PropTypes.number,
  deletedCount: PropTypes.number,
  deletedProfiles: PropTypes.array,
  match: PropTypes.object.isRequired,
  searching: PropTypes.bool.isRequired,
  sort: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isPremium: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  changePage: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleSort: PropTypes.func.isRequired
};

export default withTracker(() => {
  const profilesSub = Meteor.isClient && Meteor.subscribe('profiles');
  const totalCountProfiles = Profiles.find({}).count();
  const unfilteredCount = Profiles.find({ deleted: { $eq: 'no' } }).count();
  const deletedProfiles = Profiles.find({ deleted: { $ne: 'no' } }).fetch();
  const deletedCount = Profiles.find({ deleted: { $ne: 'no' } }).count();

  return {
    loading: !profilesSub.ready(),
    profiles: Profiles.find({}, { sort: { name: 1 } }).fetch(),
    totalCountProfiles,
    deletedProfiles,
    unfilteredCount,
    deletedCount
  };
})(VideoProfiles);
